import React from 'react'
import { Container, Divider } from 'semantic-ui-react'

export default () => (
  <div>
  <Container text>
    <h1 style={{ fontSize: '5rem', marginBottom: '0.1364em', marginTop: '0em'}}>Hello.</h1>
    <p>My name is Krišjānis Gaidis. I was born in Latvia. I’m an iOS engineer based in New York City.</p>

    <h1>Links.</h1>
    <p>
      <a href="https://twitter.com/kgaidis" target="_blank">Twitter</a>
      <b> · </b>
        <a href="https://www.linkedin.com/in/%F0%9F%91%8B-krisjanis-gaidis-1486a848" target="_blank"> LinkedIn</a>
      <b> · </b>
      <a href="https://github.com/kgaidis" target="_blank"> GitHub</a>
      <b> · </b>
      <a href="https://stackoverflow.com/users/826435/kgaidis" target="_blank"> Stack Overflow</a>
    </p>

    <h1>Projects.</h1>
      <p>Download <a href="https://apps.apple.com/app/block-apps-distractions-focus/id1645639057" target="_blank">Refocus</a> - an app that blocks distracting apps & websites. It's like Screen Time, but better.</p>
    <p>See <a href="https://apps.apple.com/us/app/nudgy-motivation-quotes/id1563589914" target="_blank">Nudgy</a> - an app that will send you quotes & reminders that help you grow.</p>
    <p>Check out <a href="https://itunes.apple.com/app/id955015185" target="_blank">Gym List</a> - a simple lifting app that stores routines, exercises, and sets.</p>
    <p>Read <a href="https://recontrol.co" target="_blank">Recontrol</a> - a blog summarizing various self-improvement topics.</p>
  </Container>
  </div>
);

    // <h1>Writing.</h1>
    // <p>Meow Meow.</p>


// <center>
//   <div class="ui divider" style={{ width: '50%' }}></div>
//   <p>
//     <a href="https://twitter.com/kgaidis" target="_blank">Twitter</a>
//     <b> · </b>
//     <a href="https://www.linkedin.com/in/%F0%9F%91%8B-krisjanis-gaidis-1486a848" target="_blank"> LinkedIn</a>
//     <b> · </b>
//     <a href="https://github.com/kgaidis" target="_blank"> GitHub</a>
//     <b> · </b>
//     <a href="https://stackoverflow.com/users/826435/kgaidis" target="_blank"> Stack Overflow</a>
//   </p>
// </center>